import React from 'react';
import { FiAlertTriangle, FiX } from 'react-icons/fi';

const ErrorModal = ({ isOpen, onClose, onAction, message, actionText }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white dark:bg-gray-800 rounded-lg p-6 max-w-md w-full mx-4 shadow-xl">
        <div className="flex items-start justify-between mb-4">
          <div className="flex items-center">
            <FiAlertTriangle className="text-red-500 w-6 h-6 mr-2" />
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
              Warning
            </h2>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-500 focus:outline-none"
          >
            <FiX className="w-6 h-6" />
          </button>
        </div>
        
        <div className="mt-3">
          <p className="text-gray-600 dark:text-gray-300">
            {message}
          </p>
        </div>

        <div className="mt-6 flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-500 hover:text-gray-700 font-medium rounded-md border border-gray-300 hover:border-gray-400 focus:outline-none"
          >
            Cancel
          </button>
          <button
            onClick={onAction}
            className="px-4 py-2 bg-blue-500 text-white font-medium rounded-md hover:bg-blue-600 focus:outline-none"
          >
            {actionText || 'Create EOWR'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorModal;